import { AxiosResponse } from 'axios';
import Vue from 'vue';
import { VueForm } from '../interfaces';

export const editMixin = Vue.extend({
  props: {
    editedItem: Object,
    value: Boolean,
  },
  data() {
    return {
      crud: {},
      defaultCrud: {},
      loading: false,
    };
  },
  computed: {
    edition(): boolean {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('edition method is deprecated, use isEdition instead');
      }
      return this.isEdition;
    },
    isEdition(): boolean {
      return !!this.editedItem;
    },
  },
  methods: {
    poster(_value: any): AxiosResponse<any> {
      return { data: '' } as AxiosResponse;
    },
    async onSuccess() {
      const form = this.$refs.form as VueForm;
      if (!form.validate()) return;
      try {
        this.loading = true;
        const response = await this.poster(this.crud);
        this.$emit('new-item', response.data);
        this.$emit('input', false);
      } finally {
        this.loading = false;
      }
    },
    onReject() {
      this.$emit('input', false);
    }
  },
  watch: {
    editedItem(value) {
      if (value) {
        this.crud = JSON.parse(JSON.stringify(value));
      } else {
        this.crud = JSON.parse(JSON.stringify(this.defaultCrud));
        (this.$refs.form as VueForm).resetValidation();
      }
    },
    value(value) {
      if (value) {
        if (!this.editedItem) {
          this.crud = JSON.parse(JSON.stringify(this.defaultCrud));
        } else {
          this.crud = JSON.parse(JSON.stringify(this.editedItem));
        }
        if (this.$refs.form) {
          (this.$refs.form as VueForm).resetValidation();
        }
      }
    },
  },
  mounted() {
    if (this.editedItem) {
      this.crud = JSON.parse(JSON.stringify(this.editedItem));
    } else this.crud = JSON.parse(JSON.stringify(this.defaultCrud));
  },
});
